import { render, staticRenderFns } from "./data74.vue?vue&type=template&id=15b31b6a&scoped=true&"
import script from "./data74.vue?vue&type=script&lang=js&"
export * from "./data74.vue?vue&type=script&lang=js&"
import style1 from "./data74.vue?vue&type=style&index=1&id=15b31b6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b31b6a",
  null
  
)

export default component.exports